module.exports = __webpack_public_path__ + "img/icon_trading.733e50e8.c52183d3.svg";